import c from 'classnames';
import React, { PropsWithChildren } from 'react';
import '../base.css';
import Footer from './Footer';
import Header from './Header';
import SEO from './SEO';

interface StandardPageProps extends PropsWithChildren<{}> {
    subtitle?: string;
    className?: string;
}

export default ({ subtitle, className, children }: StandardPageProps) => {
    return (
        <div className={c('Page', className)}>
            <SEO subtitle={subtitle} />
            <Header />
            <div>{children}</div>
            <Footer />
        </div>
    );
};
